
import { TemplateResult, css, html } from "lit";
import { property } from "lit/decorators/property.js";
import '@pushengineering/push-web-components/text'

import CirkayElement from "../../internal/CirkayElement";
import { detectMobilePlatform } from '../../utils/helpers'

export class MobilePass extends CirkayElement {

    private mobile = detectMobilePlatform()
    private hideAndroid = false
    private hideIos = false

    /** When true logs out extra infomation  */
    @property({ type: Boolean })
    debugLogging: boolean = false
     
    @property({ type: String }) fanPassTitle = 'Fan Pass'

    @property({ type: String }) androidLink = ''

    @property({ type: String }) appleLink = ''

    @property({ type: String }) downloadLink = ''

    @property({ type: String }) apiKey = ''

    @property({ type: Boolean }) displayIntro = false

    public connectedCallback(): void {
        super.connectedCallback()
        switch (this.mobile) {
            case 'iOS Phone':
                this.hideAndroid = true
                break;
            case 'Android Phone':
                this.hideIos = true
                break;                
        }
    }

    /**
     * Logs a message to the console if debugging is enabled.
     *
     * @param message - The primary message to log.
     * @param optionalParams - Additional optional parameters to log.
     */
    logging(message?: any, ...optionalParams: any[]): void {
        if (this.debugLogging) {
            console.log(`${message}`, ...optionalParams)
        }
    }

    /**
     * Renders the login component.
     *
     * This method logs the current state and returns a TemplateResult
     * that contains a div element. The div element's class is set to 'hidden'
     * if the `hidden` property is true, otherwise it is an empty string.
     * The content of the div is generated by the `renderInline` method.
     *
     * @returns {TemplateResult} The rendered template.
     */
    public render(): TemplateResult {
        this.logging('render / state')

        if (this.appleLink === '' && this.androidLink === '') {
          return html``
        }

        return html`
            <div part="mobile-pass">
              ${this.displayIntro ? html`
                <pu-text
                    part="base-mobile-pass-title base-text base-title"
                    exportparts="base:mobile-pass-title"
                    as="h2"
                    variant="bodyMd"
                    fontWeight="regular"
                    withoutMargin
                    spacing="normal"
                >Add to Wallet</pu-text>
                ${this.appleLink && this.androidLink && (!this.hideAndroid && !this.hideIos) ? html`
                    <pu-text
                        part="base-mobile-pass-action-text base-text base-body"
                        exportparts="base:mobile-pass-action-text"
                        as="p"
                        variant="bodyMd"
                        fontWeight="regular"
                        withoutMargin
                        spacing="normal"
                    >Save your ${this.fanPassTitle} to Apple Wallet or Google Wallet.</pu-text>
                ` : null}              
                ${this.appleLink && !this.hideIos && !this.androidLink ? html`
                    <pu-text
                        part="base-mobile-pass-action-text base-text base-body"
                        exportparts="base:mobile-pass-action-text"
                        as="p"
                        variant="bodyMd"
                        fontWeight="regular"
                        withoutMargin
                        spacing="normal"
                    >Save your ${this.fanPassTitle} to Apple Wallet.</pu-text>
                ` : null}
                ${!this.appleLink && !this.hideAndroid  && this.androidLink ? html`
                    <pu-text
                        part="base-mobile-pass-action-text base-text base-body"
                        exportparts="base:mobile-pass-action-text"
                        as="p"
                        variant="bodyMd"
                        fontWeight="regular"
                        withoutMargin
                        spacing="normal"
                    >Save your ${this.fanPassTitle} to Google Wallet.</pu-text>
                ` : null}                
              ` : null}
              <div part="wallet-buttons" class="wallet-buttons">                  
                  ${this.appleLink && !this.hideIos ? html`
                    <!-- Apple Wallet Button -->
                    <a part="mobile-pass-link" href="${this.mobile === 'iOS Phone' ? this.appleLink : this.downloadLink}" target="_blank">
                        <img part="apple-wallet-image" src="https://cdn.n3xus.services/production/assets/images/US-UK_Add_to_Apple_Wallet_RGB_101421.svg" 
                            alt="Add to Apple Wallet">
                    </a>                  
                  ` : html``}

                  ${this.androidLink && !this.hideAndroid ? html`
                        <!-- Google Wallet Button -->
                        <a part="mobile-pass-link" href="${this.mobile === 'Android Phone' ? this.androidLink : this.downloadLink}" target="_blank" class="google-wallet-btn">
                            <img part="google-wallet-image" src="https://cdn.n3xus.services/production/assets/images/enGB_add_to_google_wallet_wallet-button.svg" 
                            alt="Add to Google Wallet">
                        </a>
                      ` : html``}

              </div>                
            </div>
        `
    }

    static override styles = css`
        :host {
            font-size: var(--fp-font-size-base, 1em);
        }

        .wallet-buttons {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 15px;
            margin-top: 20px;
            margin-bottom: 20px;
        }
        .wallet-buttons img {
            width: 200px;
            cursor: pointer;
        }    
        .google-wallet-btn {
            background: none;
            border: none;
            padding: 0;
            display: inline-block;
        }
        .google-wallet-btn img {
            display: block;
            width: 200px; /* Adjust as needed */
        }
    `
}
